import { InputLabel, Grid, Typography, ClickAwayListener, Paper, FormHelperText, CircularProgress } from '@material-ui/core';
import './loanStyle.scss';
import { DatePicker, SelectBox, TextBox } from '../../../Core/FormInput';
import { useCallback, useContext, useEffect, useState } from 'react';
import { LoanVehicleContext } from './loanVehicle-provider';
import { downldLoavVehicle } from '../../../Core/Service/wheelServices/wheel-services';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function LoanVehicleDetails(props) {
    const { vehicleDetails, handleVehicleDetails, getRegNubmer, errors, state, searchVehicleList } = useContext(LoanVehicleContext);
    const [showDropdown, setShowDropdown] = useState(false);
    const [stateLoader, setStateLoader] = useState({});

    console.log(vehicleDetails, 'vehicleDetails');
    const dwnldPdf = async () => {
        setStateLoader((st) => ({ ...st, showDwnldLoader: true }));
        let res = await downldLoavVehicle(props.tCardID, vehicleDetails.vehicleReg);
        // console.log(res);
        setStateLoader((st) => ({ ...st, showDwnldLoader: false }));
    };

    return (
        <Grid container spacing={1} className="mainSection">
            <Grid item xs={12}>
                <Grid container justifyContent="space-between">
                    <Grid item xs>
                        <div className="Loan_Veh_heading">Loan Vehicle Details</div>
                    </Grid>
                    <Grid item>
                        {stateLoader.showDwnldLoader ? (
                            <CircularProgress size={30} style={{ marginRight: 10 }} />
                        ) : (
                            <CloudDownloadIcon color="primary" style={{ fontSize: 30, cursor: 'pointer', marginRight: 10 }} onClick={dwnldPdf} />
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
                <Grid item xs={12} sm={6} md={6} lg={3} style={{ position: 'relative' }}>
                    <InputLabel shrink error required style={{ marginBottom: '8px' }}>
                        Loan Vehicle Reg
                    </InputLabel>
                    <SelectBox
                        List={searchVehicleList}
                        name="loanVehicleID"
                        value={vehicleDetails.loanVehicleID}
                        onChange={handleVehicleDetails}
                        autoFocus
                        disabled={state.isVehicleReceived || state.isReadonly}
                    />
                    {errors.vehicleReg && <FormHelperText error>{errors.vehicleReg}</FormHelperText>}
                </Grid>
                {/* ... other Grid items ... */}
            </ClickAwayListener>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <InputLabel shrink error required>
                    Vehicle model
                </InputLabel>
                <TextBox
                    name="vehicleModel"
                    value={vehicleDetails.vehicleModel}
                    onChange={handleVehicleDetails}
                    disabled={state.isVehicleReceived || state.isReadonly}
                />
                {errors.vehicleModel && <FormHelperText error>{errors.vehicleModel}</FormHelperText>}
            </Grid>
            {/* <Grid item xs={12} sm={6} md={6} lg={3}>
                <InputLabel shrink>Insurance Value</InputLabel>
                <TextBox name="insuranceValue" value={vehicleDetails.insuranceValue} onChange={handleVehicleDetails} disabled={state.isVehicleReceived} />
                {/* {errors.insuranceValue && <FormHelperText error>{errors.insuranceValue}</FormHelperText>} 
            </Grid> */}
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <InputLabel shrink style={{ marginBottom: '8px' }} error required>
                    Date
                </InputLabel>
                <DatePicker
                    name="dateCreated"
                    value={vehicleDetails.dateCreated}
                    onChange={handleVehicleDetails}
                    disabled={state.isVehicleReceived || state.isReadonly}
                />
                {errors.dateCreated && <FormHelperText error>{errors.dateCreated}</FormHelperText>}
            </Grid>
        </Grid>
    );
}

export default LoanVehicleDetails;
